// Relaciones num(dividendo)/den(divisor) que puede devolver el adaptador (ver suaje.service.ts)
export const RELACIONES_MAP = {
  1: { num: 1, den: 1 },
  '2/3': { num: 2, den: 3 },
  '1/2': { num: 1, den: 2 },
};

/**
 * Bocas al desarrollo de impresión: si el suaje es plano se ajustan según la relación del
 * adaptador (EtiquetasDesarrollo × divisor / dividendo); si no es plano, se usa tal cual.
 *
 * @param {object} row - Suaje (o fila de la grilla) con SuajeTipo, EtiquetasDesarrollo y Adaptador
 * @returns {number}
 */
export function calcularEtiquetasDesarrolloImpresion(row) {
  const etiquetasDesarrollo = row?.EtiquetasDesarrollo;
  const esPlano = row?.SuajeTipo?.ClaveInterna === 'plano';
  const relacion = esPlano ? RELACIONES_MAP[row?.Adaptador?.r] : null;

  if (!relacion) {
    return etiquetasDesarrollo;
  }

  return (etiquetasDesarrollo * relacion.den) / relacion.num;
}

/**
 * Gap al desarrollo (mm): diferencia entre el desarrollo del cilindro y la suma de las
 * medidas al desarrollo de cada etiqueta, repartida entre la cantidad de etiquetas.
 * gap = (desarrollo - etiquetasDesarrollo × medidaDesarrollo) / etiquetasDesarrollo
 *
 * @param {number} desarrollo - Desarrollo del cilindro (mm)
 * @param {number} etiquetasDesarrollo - Cantidad de etiquetas al desarrollo
 * @param {number} medidaDesarrollo - Medida al desarrollo de la etiqueta (mm)
 * @returns {number}
 */
export function calcularGapDesarrollo(desarrollo, etiquetasDesarrollo, medidaDesarrollo) {
  if (!etiquetasDesarrollo) return 0;
  const gap = (desarrollo - etiquetasDesarrollo * medidaDesarrollo) / etiquetasDesarrollo;
  return parseFloat(gap.toFixed(4));
}
